import type { TDaDataGender } from '../models';

export interface ISuggestionData {
    gender: string;
    name: string;
    patronymic: string;
    qc: string;
    source: string;
    surname: string;
}

export interface ISuggestion {
    data: ISuggestionData;
    // eslint-disable-next-line camelcase
    unrestricted_value: string;
    value: string;
}

export interface ISuggestionRequest {
    controller: AbortController;
    gender: TDaDataGender;
    namePart?: TNamePart;
    value: string;
}

export const LAST_NAME = 'SURNAME';
export const FIRST_NAME = 'NAME';
export const PATRONYMIC = 'PATRONYMIC';

export type TNamePart = typeof LAST_NAME | typeof FIRST_NAME | typeof PATRONYMIC;
